import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    userToDelete,
    listTenant,
    updateTenant,
    uploadKYCByUser,
    fetchKYCListByTenant,
    getAdsCount,
    uploadKYCByTenant,
    uploadKycEditData,
    updatekycDoc,
    createTenant,
    listTenantSubAdmin,
    updateTenantSubAdmin,
    createTenantSubAdmin,
    getTenantDetailByID,
    updateTenantPreferences,
    getTenantPreferences,
    getTenantListLite,
    setPaymentConfig,
    getTenantAnalyticReport,
    updateStatus,
    fetchKYCListByUser,
    fetchUserManagementDetail,
    fetchSlugName,
    updatePreferencesTenant,
    updateGatewayPreferencesTenant,
    filterListTenant,
    fetchPaymentGatewayList,
    fetchB2bGatewayList,
    fetchPaymentGatewayConfigure,
    tenantConfig,
    fetchB2bGatewayConfigure,
    fetchConfiguredGatewayList,
    fetchB2bConfiguredGateway,
    getNotificantionData,
    getExtendedList,
    addExtendedTemplate,
    updateExtendedItem,
    deleteExtendedAttr,
    getDeleveryData,
    configureDunzo,
    getDeviceBindingData,
    getConfiguredListNotification,
    configureNotification,
    getServiceProviders,
    getTenantDetailsBySubDomain,
    KYCPreferenceList,
    updateKycPreference,
    updateKycStatus,
    getTenantConfig,
} from "../../services/tenant";

@Module({
    namespaced: true,
})
export default class Item extends VuexModule {
    // state
    tenantsList = [];
    userListMeta = {};
    tenantConfigList = {};
    adsCount = [];
    tenantSubAdminList = [];
    currentTenantAccess = "";
    tenantPreferences = {};
    paymentGatewayList = [];
    b2bGatewayList = [];
    b2bGatewayConfigure = [];
    b2bConfiguredGateway = [];
    tenantListLite = [];
    kycUser = [];
    kycTenant = [];
    userData = {};
    paymentGatewayConfigure = [];
    configuredGateway = [];
    notificationData = [];
    extendedList = {};
    addExtended = null;
    updateExtended = null;
    deleteExtended = null;
    deleveryList = [];
    deviceBinding = {};
    notificationConfigured = [];
    serviceProviders = [];
    kycVerificationList = {};
    extendedData = {};
    // tenant = []

    // actions
    @Action
    public async actionTenantConfigList() {
        try {
            const data = await getTenantConfig();
            this.context.commit("setTenantConfig", data.data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getTenantDetailsBySubDomain(payload) {
        try {
            const data = await getTenantDetailsBySubDomain(payload);
            return data.data.response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async tenantConfig(payload) {
        try {
            const data = await tenantConfig(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchSlugName(payload) {
        try {
            const data = await fetchSlugName(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchKYCListByUser(payload) {
        this.context.commit("setKycByUser", {}); // reset
        try {
            const res = await fetchKYCListByUser(payload.id);
            this.context.commit("setKycByUser", res.data.response);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchKYCPreferenceList(payload) {
        this.context.commit("setKycByUser", {}); // reset
        try {
            const res = await KYCPreferenceList(payload);
            this.context.commit(
                "setKycVerificationList",
                res.data.response.kycVerification,
            );
            return res;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateKycConfig(payload) {
        try {
            return await updateKycPreference(payload);
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateStatus(payload) {
        try {
            const data = await updateStatus(payload.id, payload.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async viewUserManagementDetail(payload) {
        try {
            const data = await fetchUserManagementDetail(payload);
            this.context.commit("setUserManagementData", data.data.response);
            let extendedData = {};
            if (data.data.response.extendedAttributes) {
                for (const [key, value] of Object.entries(
                    data.data.response.extendedAttributes,
                )) {
                    if (key == "firstLogin") continue;
                    if (typeof value == "object") continue;
                    extendedData[key] = value;
                }
            }
            this.context.commit("setExtendedData", extendedData);
            return data.data.response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchTenantAnalyticReport(payload) {
        try {
            if (Array.isArray(payload)) {
                const responseData = {};
                const allData = payload.map(async (x) => {
                    const res = await getTenantAnalyticReport(x.payload);
                    responseData[x.key] = res.data.response;
                    return;
                });
                await Promise.all(allData);
                return responseData;
            }
            const data = await getTenantAnalyticReport(payload);
            return data.data.response;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchTenantsListLite() {
        try {
            const data = await getTenantListLite();
            this.context.commit("setTenantListLite", data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async setPaymentConfigAction(payload) {
        try {
            const data = await setPaymentConfig(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async filterListTenant(payload) {
        try {
            const data = await filterListTenant(payload);
            this.context.commit("setTenantList", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchTenantsList() {
        try {
            const data = await listTenant();
            this.context.commit("setTenantList", data.data);
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateTenantById(payload) {
        try {
            const data = await updateTenant(payload.id, payload.data);
            this.context.dispatch("fetchTenantsList");
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async updateKycStatusAction(payload) {
        try {
            const data = await updateKycStatus(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getTenantDetailByID(payload) {
        try {
            const data = await getTenantDetailByID(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async createTenant(payload) {
        try {
            const data = await createTenant(payload);
            this.context.dispatch("fetchTenantsList");
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchAdsCount() {
        try {
            const data = await getAdsCount();
            this.context.commit("getAdsCount", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchKYCListByTenant(Id) {
        try {
            const data = await fetchKYCListByTenant(Id);
            this.context.commit("setTenantKyc", data.result.reponse);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async submitKYCByTenant(payload) {
        try {
            const data = await uploadKYCByTenant(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async updateKycData(payload) {
        try {
            const data = await uploadKycEditData(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateKYCByTenant(payload) {
        try {
            const data = await updatekycDoc(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async fetchTenantSubAdminList(payload) {
        try {
            const data = await listTenantSubAdmin(payload);
            this.context.commit("setTenantSubAdminList", data.response);
            this.context.commit("setUserListMeta", data.meta);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async deleteUser(payload) {
        try {
            const data = await userToDelete(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async createTenantSubAdmin(payload) {
        try {
            const data = await createTenantSubAdmin(payload);
            this.context.dispatch("fetchTenantSubAdminList");
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateTenantSubAdminById(payload) {
        try {
            const data = await updateTenantSubAdmin(payload.id, payload.data);
            this.context.dispatch("fetchTenantSubAdminList");
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async submitKYCByUser(payload) {
        try {
            const data = await uploadKYCByUser(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async setTenantCatalogAccess(payload) {
        try {
            this.context.commit("setCurrentTenantCatalogAccess", payload);
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateTenantPreferences(payload) {
        try {
            const data = await updateTenantPreferences(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updatePreferencesTenant(payload) {
        try {
            const data = await updatePreferencesTenant(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async updateGatewayPreferencesTenant(payload) {
        try {
            const data = await updateGatewayPreferencesTenant(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getTenantPreferences(payload) {
        try {
            const data = await getTenantPreferences(payload);
            this.context.commit("setTenantPreference", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async getPaymentGatewayList() {
        try {
            const data = await fetchPaymentGatewayList();
            this.context.commit("setPaymentGatewayList", data.data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getPaymentGatewayConfigure(payload) {
        try {
            const data = await fetchPaymentGatewayConfigure(payload);
            this.context.commit("setPaymentGatewayConfig", data.data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getConfiguredGatewayList(id) {
        try {
            const data = await fetchConfiguredGatewayList(id);
            this.context.commit("setConfiguredGateway", data.data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getB2bGatewayList() {
        try {
            const data = await fetchB2bGatewayList();
            this.context.commit("setB2bGatewayList", data.data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getB2bGatewayConfigure(payload) {
        try {
            const data = await fetchB2bGatewayConfigure(payload);
            this.context.commit("setB2bGatewayConfig", data.data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async getB2bConfiguredGateway(payload) {
        try {
            const data = await fetchB2bConfiguredGateway(payload);
            this.context.commit("setB2bConfiguredGateway", data.data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    @Action
    public async setNotificationListData() {
        try {
            const data = await getNotificantionData();
            this.context.commit("setNotificationList", data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async setExtendedAttributeList() {
        try {
            const data = await getExtendedList();
            this.context.commit("setExtendedList", data.data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async saveExtendedData(payload) {
        try {
            const data = await addExtendedTemplate(payload);
            this.context.commit("saveExtendedFields", data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async editExtendedItem(payload) {
        try {
            const data = await updateExtendedItem(payload.id, payload.data);
            this.context.dispatch("setExtendedAttributeList");
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async deleteExtendedItem(payload) {
        try {
            const data = await deleteExtendedAttr(payload);
            this.context.dispatch("setExtendedAttributeList");
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async setDeleveryItemListData() {
        try {
            const data = await getDeleveryData();
            this.context.commit("setDeleveryList", data.data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async configureDunzoAction(payload) {
        try {
            const data = await configureDunzo(payload);
            this.context.dispatch("setDeleveryItemListData");
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async setDeviceBindingData(id) {
        try {
            const data = await getDeviceBindingData(id);
            this.context.commit(
                "setDeviceBindingMutation",
                data.data.response.deviceBinding,
            );
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async setNotificationConfigured(id) {
        try {
            const data = await getConfiguredListNotification(id);
            this.context.commit(
                "getNotificationConfigured",
                data.data.response,
            );
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async configureNotificationAction(payload) {
        try {
            const data = await configureNotification(payload);

            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async getServiceProvidersAction() {
        try {
            const data = await getServiceProviders();
            this.context.commit("getServiceProvidersList", data.data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    // mutations
    @Mutation
    public setTenantKyc(data: any) {
        this.kycTenant = data;
    }

    @Mutation
    public setKycVerificationList(data: any) {
        this.kycVerificationList = data;
    }

    @Mutation
    public setKycByUser(data: any) {
        this.kycUser = data;
    }

    @Mutation
    public setTenantList(data: any) {
        this.tenantsList = data;
    }
    @Mutation
    public setExtendedData(data: any) {
        this.extendedData = data;
    }

    // @Mutation
    // public setTenantListByType(data: any) {
    //   this.tenant = data;
    // }

    @Mutation
    public setUserManagementData(data: any) {
        this.userData = data;
    }
    @Mutation
    public setTenantConfig(data: any) {
        this.tenantConfigList = data;
    }

    @Mutation
    public setTenantListLite(data: any) {
        this.tenantListLite = data;
    }

    @Mutation
    public getAdsCount(data: any) {
        this.adsCount = data;
    }

    @Mutation
    public setTenantSubAdminList(data: any) {
        this.tenantSubAdminList = data;
    }

    @Mutation
    public setUserListMeta(data: any) {
        this.userListMeta = data;
    }

    @Mutation
    public setCurrentTenantCatalogAccess(data: any) {
        this.currentTenantAccess = data;
    }

    @Mutation
    public setTenantPreference(data: any) {
        this.tenantPreferences = data;
    }

    @Mutation
    public setPaymentGatewayList(data: any) {
        this.paymentGatewayList = data;
    }

    @Mutation
    public setPaymentGatewayConfig(data: any) {
        this.paymentGatewayConfigure = data;
    }

    @Mutation
    public setConfiguredGateway(data: any) {
        this.configuredGateway = data;
    }

    @Mutation
    public setB2bGatewayList(data: any) {
        this.b2bGatewayList = data;
    }

    @Mutation
    public setB2bGatewayConfig(data: any) {
        this.b2bGatewayConfigure = data;
    }

    @Mutation
    public setB2bConfiguredGateway(data: any) {
        this.b2bConfiguredGateway = data;
    }

    @Mutation
    public setNotificationList(data: any) {
        this.notificationData = data;
    }
    @Mutation
    public setExtendedList(data: any) {
        this.extendedList = data;
    }
    @Mutation
    public saveExtendedFields(data: any) {
        this.addExtended = data;
    }
    @Mutation
    public updateExtendedField(data: any) {
        this.updateExtended = data;
    }
    @Mutation
    public deleteExtendedFields(data: any) {
        this.deleteExtended = data;
    }

    @Mutation
    public setDeleveryList(data: any) {
        this.deleveryList = data;
    }
    @Mutation
    public setDeviceBindingMutation(data: any) {
        this.deviceBinding = data;
    }
    @Mutation
    public getNotificationConfigured(data: any) {
        this.notificationConfigured = data;
    }
    @Mutation
    public getServiceProvidersList(data: any) {
        this.serviceProviders = data;
    }
    // getters
    // get GetTenantByType() {
    //   return this.tenant;
    // }
    get GetTenantList() {
        return this.tenantsList;
    }

    get GetTenantLiteList() {
        return this.tenantListLite;
    }

    get GetTenantSubAdminList() {
        return this.tenantSubAdminList;
    }

    get GetTenantCatalogAccess() {
        return this.currentTenantAccess;
    }

    get GetTenantLanguage() {
        if (this.tenantPreferences.hasOwnProperty("defaultLanguage")) {
            return this.tenantPreferences["defaultLanguage"];
        } else {
            return "en";
        }
    }

    get GetTenantPreferences() {
        return this.tenantPreferences;
    }

    get GetPaymentGatewayList() {
        return this.paymentGatewayList;
    }

    get GetPaymentGatewayConfigure() {
        return this.paymentGatewayConfigure;
    }

    get GetConfiguredGateway() {
        return this.configuredGateway;
    }

    get GetB2bGatewayList() {
        return this.b2bGatewayList;
    }

    get GetB2bGatewayConfigure() {
        return this.b2bGatewayConfigure;
    }

    get GetB2bConfiguredGateway() {
        return this.b2bConfiguredGateway;
    }
    get GetKycByTenant() {
        return this.kycTenant;
    }
    get GetKycByUser() {
        return this.kycUser;
    }
    get GetUserDataDetail() {
        return this.userData;
    }
}
